import { STAGES } from "../../../utils/stageManagement";
import { navItems } from "./packageWizardConfig";

export const getPackageCompletedStage = (generalInfoData) =>
  Number(generalInfoData?.current_stage) || STAGES.GENERAL;

export const isPackageSectionAccessible = (
  targetStage,
  completedStage,
  hasPackageId
) => {
  if (!hasPackageId) {
    return Number(targetStage) === STAGES.GENERAL;
  }
  let progress = Number(completedStage) || STAGES.GENERAL;
  if (progress < STAGES.ITINERARY) {
    progress = STAGES.ITINERARY;
  }
  return Number(targetStage) <= progress;
};

export const getPackageResumeSectionId = (completedStage) => {
  const stage = Number(completedStage) || STAGES.GENERAL;
  const match = navItems.find((item) => item.stage === stage);
  if (match) return match.id;

  const pending = navItems.find((item) => item.stage > stage);
  return pending?.id || navItems[navItems.length - 1]?.id || "general";
};
